<template>
  <span>
  <Portlet
    :full-height="true"
    :no-padding="true"
    :headSeparator="false"
    :hasFooter="true"
  >


    <template slot="Content">
      <div v-if="uploadData.reports.length ===0" style=" margin: auto;  width: 50%;  top: 50%;  padding: 10px; font-size: 21px">
        You have no uploads yet.
      </div>

<!--      <div style="font-style: italic;text-align: right;padding-right: 10px ;font-size: 14px">Imported by: {{uploadData.createdBy }} </div>-->
      <br>
        <table v-if="uploadData.reports.length > 0"  :class="`table table-stripped table-condensed`" >

          <thead class="sticky">

           <tr>
             <th></th>
             <th :key="'checkbox'">Name</th>
              <th :key="'OriginalFilename'">   Station   </th>
              <th :key="'Title'">   Status   </th>
              <th :key="'Artist'">   Total  </th>
              <th :key="'StatusUpload'">  Fail </th>
              <th :key="'StatusConversion'">  Success  </th>
              <th :key="'ValidationStatus'">  Duration </th>
              <th :key="'error'">   Time </th>
              <th>    </th>
           </tr>
          </thead>
          <tbody>

                <template v-for="(prop, index) in uploadData.reports">
                <tr >
                  <td :key="`property-${1+index}`" ></td>
                      <td :key="`property-${1+index}`" >
                      <router-link style="color:#2b2b2b" :to="{name:'reportUPDetail', params:{sequenceidentifier:prop.sequenceIdentifier ,stationUid:prop.stationUid}}" >
                        Upload from  {{moment(prop.created).format("Do MMM YYYY")}}
                      </router-link>
                      </td>
                      <td class="td-xl">
                       <router-link style="color:#2b2b2b" :to="{name:'Dashboard', params:{stationUid:prop.stationUid}}" >
                            {{filteredStations(prop.stationUid)[0].name}}
                       </router-link>
                      </td>
                        <td :key="`property-uploadStatus-${index}`" >
<!--                           <span v-if="prop.status === false"-->
<!--                                 class="label label-sm label-warning" >IN PROGRESS</span>-->
<!--                            <span v-if="prop.status === true "-->
<!--                                  class="label label-sm label-info">COMPLETED</span>-->
                    <Tag  v-if="prop.status" :value="'IN PROGRESS'" :severity="'warning'" />
                    <Tag  v-if="!prop.status" :value="'COMPLETED'" :severity="'success'" />
                      </td>
                        <td :key="`property-uploadCoun}`">
                        {{prop.uploadCount }}
                      </td>
                       <td :key="`property-uploadFail`" >
                        {{prop.uploadFail }}
                      </td>
                      <td :key="`property-uploadSuccess`" >
                          {{prop.uploadSuccess }}
                      </td>
                      <td :key="`property-${prop.duration}`" class="td-xl">
                         <span v-if="prop.duration">00:{{moment(prop.duration ,'hh:mm:ss').format("mm:ss")}}</span>
                      </td>
                      <td :key="`property-${prop.created}`" class="td-xl">
                           {{moment.utc(prop.created).local().format("HH:mm:ss")}}
                      </td>
                  <td></td>
                  </tr>
                </template>
          </tbody>

          <tfoot class="sticky" >

          </tfoot>
        </table>
    </template>

    <template slot="">

    </template>

  </Portlet>
</span>
</template>

<script>
import Portlet from "@/components/common/Portlet";
import router from "@/router";
import store from "@/store";
import {HTTP} from "@/utils/http";
import Apis from "@/apis";
import moment from "moment";
import {mapState} from "vuex";
import Translations from "@/store/translations";
import Tag from "primevue/tag";

export default {
  name: "MasterReportListSection",
  router,
  store,
  components: {
    Tag,
    Portlet,
  },
  created() {},
  beforeDestroy(){},
  data() {
    return {
      uploadData: null,
      errorMessage: false,
      moment,
    }
  },
  computed: {},
  mounted() {
    this.loadData();
    setInterval(this.loadData, 30000);
  },
  methods: {
    filteredStations (uid) {
      // console.log(this.$store.state.stations.items , uid)
      if (this.$store.state.stations.items.length > 0) {
        return (this.$store.state.stations.items || []).filter(station => {
          console.log(station.uid === uid)
          return station.uid === uid;
        })
      }

    },
    loadData(){
      HTTP.get('Api/library/upload-reports/'+this.$route.params.since)
          .then(({ data }) => {
            this.errorMessage = false;
            this.uploadData = data.dataItem
          })
          .catch(error => {

            this.errorMessage = true;
            console.log('-------------')
            console.log('error', error)
          })

    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.back-button {
  margin-right: 20px;
  align-self: center;

  i {
    padding: 0;
    font-size: 14px;
  }
}

.title-text {
  align-self: center;
}

// Search
.portlet-search {
  display: flex;
  align-items: center;
justify-content: flex-end;
  .fa-search {
    margin-right: 20px;
    color: var(--COLOR_BRAND);
  }

  .portlet-search-advanced {
    border: 0;
    background-color: transparent;
    margin-left: 20px;
    font-size: 11px;
    font-weight: 600;
    padding: 9px 15px;
    letter-spacing: 0.7px;
    text-transform: uppercase;

    &:hover {
      text-decoration: none;
    }
  }

  .portlet-search-input {
    flex-grow: 1;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 17px;
    color: var(--COLOR_TEXT);
    border-bottom: 1px solid var(--COLOR_BRAND);

    &[value=""] {
      border-bottom: 1px solid var(--COLOR_LIGHT);
    }
    &:focus {
      border-bottom: 1px solid var(--COLOR_BRAND);
    }
  }

  .portlet-search-submit {
    margin-left: 5px;
    text-transform: uppercase;
  }

  .portlet-search-close {

    i {
      transition: color 0.2s ease-in-out;
      font-size: 20px;
    }

    &:not(:hover) {
      i {
        color: #d2d2d2;
      }
    }
  }
}
table {
  width: 100%;
  max-height: 100%;
  margin-bottom: 0;

  &.is-sorting {
    tbody {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

thead {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  z-index: 1000;
  top: 0;
  background: white; // border-bottom: 2px solid #d2d2d2;

  th {
    border-bottom: 0;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #d2d2d2;
    }
  }
}

tbody {
  background-color: #fff;
  tr.shiftable {
    td, th {
      border-bottom:1px solid var(--COLOR_BRAND) !important;
    }
    border-bottom:1px solid var(--COLOR_BRAND) !important;
  }
  tr:first-child th,
  tr:first-child td {
    border-top: 0;
  }
}

tfoot tr,
tfoot tr th,
tfoot tr td {
  vertical-align: middle;
  border-top: 1px solid #d2d2d2;
}

thead tr,
thead tr th,
tfoot tr {
  font-size: 13px;
  line-height: 16px;
}

tfoot {
  font-weight: bold;
}

td {
  padding: 0 12px;
  /* Keep it : to have more data lines on screen */
  vertical-align: middle;

  &:not(:last-child) {
    border-right: 1px dashed #d2d2d2;
  }

  &.td-m {
    min-width: 80px;
  }

  &.td-xl {
    min-width: 120px;
  }

  &.td-actions {
    &:hover {
      z-index: 801;
    }

    .td-actions-wrapper {
      display: flex;

      > *:not(:first-child) {
        margin-left: 8px;
      }
    }

    a {
      transition: opacity 0.15s ease-in-out;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    i {
      &.fa-exclamation-triangle {
        color: #fe6b5b;
      }
      &.fa-check {
        color: #89c42c;
      }
    }

    .filled {
      position: relative;

      .filled-toggle {
        &:hover {
          & + .filled-dropdown {
            display: block;
          }
        }
      }

      .filled-dropdown {
        display: none;
        position: absolute;
        top: calc(100% + 5px);
        right: 0;
        width: 300px;
        padding: 10px 15px 17px;
        border-radius: 5px;
        box-shadow: 0 1px 21px 2px rgba(0, 0, 0, 0.2);
        background-color: #fff;
        font-size: 14px;
        line-height: 1.2;

        span {
          white-space: normal;
        }

        i {
          display: inline-block;
          opacity: 1;
          margin-right: 2px;
          margin-bottom: -15px;
        }

        // Extend hover surface
        &::after {
          content: "";
          position: absolute;
          top: -12px;
          left: 0;
          width: 100%;
          height: 13px;
        }

        &:hover {
          display: block;
        }
      }
    }
  }
}

tr {
  font-size: 14px;
  .fa-play {
    color: transparent;
  }
}

tr:hover .fa-play {
  color: #aaaaaa;
}

thead th,
tbody th {
  vertical-align: middle;
  color: #aaaaaa;
  font-size: 13px;
  line-height: 16px;
}

thead th {
  border-top: 0;
  padding-top: 15px;

  &:not(:first-child):not(:last-child) {
    color: #292c33;
  }

  .sort {
    display: flex;
    cursor: pointer;
    transition: color 0.15s ease-in-out;
    color: #aaaaaa;
    font-weight: 400;

    &[disabled] {
      pointer-events: none;
    }

    &.is-active {
      color: #000;
    }

    &:hover {
      text-decoration: none;
    }

    &-icons {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-left: 5px;

      i {
        font-size: 10px;
        height: 8px;
      }
    }

    @keyframes sorting {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .fa-sync-alt {
      align-self: center;
      font-size: 12px;
      margin-left: 5px;
      transform-origin: 50% 50%;
      animation: sorting 1s linear infinite;
    }
  }
}

thead th:first-child,
tbody th:first-child {
  text-align: right;
  background: white;
  vertical-align: middle;
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  left: 0;
  z-index: 800; // padding-left: 0px;

  &::before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }
}

thead th:first-child {
  z-index: 1600;
}

thead th:last-child,
tbody td:last-child {
  max-height: 100%;
  vertical-align: middle;
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  right: 0;
  z-index: 800;
  background: #fff;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }
}

thead th:last-child,
tfoot th:last-child {
  position: sticky;
  right: 0;
  z-index: 1600;
}

thead th[role="rowheader"] i,
tbody td:last-child i,
tbody th[role="rowheader"] i {
  line-height: 30px;
  display: inline;
  padding: 10px;
  cursor: pointer;
}

thead th:last-child {
  background: white;
}

tbody tr[role="rowheader"] i,
tbody td:last-child a {
  text-decoration: none;
}
tbody tr {
  font-size: 15px;
  line-height: 45px;
}

td input[type="text"] {
  width: calc(100% - 20px);
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  background-clip: padding-box;
  outline: none;
  &:focus {
    background-color: rgba(#fff, 0) !important;
    border-bottom: 1px solid;
  }
}

col.col-l {
  min-width: 20em;
}

col.col-s {
  min-width: 10em;
}

col.col-xs {
  width: 5em;
}

col.actions {
  background: #495057;
}
.label-warning {
  background-color: #f0ad4e;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
.label-info {
  background-color: #5cb85c;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
.label-danger{
  background-color:#d9534f;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
</style>
